import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

// chamadas de reboques. O superadmin informa a empresa (cliente_id); para os demais o servidor usa a empresa do usuario.
const p = (clienteId?: string) => (clienteId ? { params: { cliente_id: clienteId } } : {})
const pc = (clienteId: string | undefined, extra: Record<string, any> = {}) => ({ params: { ...(clienteId ? { cliente_id: clienteId } : {}), ...extra } })

const lista = (d: any): any[] => (Array.isArray(d) ? d : [])
const conjunto = (d: any) => ({ limite: Number(d?.limite) || 2, atrelados: lista(d?.atrelados) })

export const reboquesApi = {
  listar: async (clienteId?: string, soLivres = false): Promise<any[]> => lista((await axios.get(`${API}/reboques`, pc(clienteId, soLivres ? { livres: 1 } : {}))).data),
  atrelados: async (ativoId: string, clienteId?: string): Promise<{ limite: number; atrelados: any[] }> => conjunto((await axios.get(`${API}/ativos/${ativoId}/reboques`, p(clienteId))).data),
  atrelar: async (ativoId: string, ids: string[], clienteId?: string): Promise<{ limite: number; atrelados: any[] }> => conjunto((await axios.put(`${API}/ativos/${ativoId}/reboques`, { reboque_ids: ids }, p(clienteId))).data),
  historico: async (ativoId: string, clienteId?: string): Promise<any[]> => lista((await axios.get(`${API}/ativos/${ativoId}/reboques`, pc(clienteId, { historico: 1 }))).data?.historico),
  salvar: async (id: string | null, corpo: any, clienteId?: string): Promise<any> => (id ? await axios.put(`${API}/reboques/${id}`, corpo, p(clienteId)) : await axios.post(`${API}/reboques`, corpo, p(clienteId))).data,
  excluir: async (id: string, clienteId?: string) => (await axios.delete(`${API}/reboques/${id}`, p(clienteId))).data,
  tipoReboque: async (): Promise<any | null> => lista((await axios.get(`${API}/tipo-ativo`)).data).find((t) => t.reboque) || null,
}

export const erroDe = (e: any, padrao: string) => e?.response?.data?.erro || padrao

// 1o e 2o reboque, etc.
export const ordemTxt = (n: number) => `${n}º reboque`
export const eixosTxt = (n: any) => (n ? `${n} ${Number(n) === 1 ? "eixo" : "eixos"}` : "—")

// ---------------------------------------------------------------- desenho dos eixos do modelo de reboque
// cada eixo tem 2 pneus (um de cada lado) ou 4 (dois de cada lado, rodado duplo); estepes de 0 a 2. O servidor repete estas regras.
export interface DesenhoEixos { pneus: number[]; estepes: number }
export const MAX_EIXOS = 9
export const DESENHO_VAZIO: DesenhoEixos = { pneus: [], estepes: 1 }
export const totalPneus = (pneus: number[]) => pneus.reduce((s, p) => s + p, 0)
export const estepesTxt = (n: number) => (n === 0 ? "sem estepe" : n === 1 ? "1 estepe" : `${n} estepes`)
export const desenhoValido = (d: DesenhoEixos) => d.pneus.length >= 1 && d.pneus.length <= MAX_EIXOS && d.pneus.every((p) => p === 2 || p === 4) && Number.isInteger(d.estepes) && d.estepes >= 0 && d.estepes <= 2
// desenho gravado no modelo; modelo antigo (so a quantidade) = todos os eixos com 4 pneus e 1 estepe, como o sistema ja assumia
export const desenhoDoModelo = (m: any): DesenhoEixos | null => {
  const lista = Array.isArray(m?.eixos_config) && m.eixos_config.length ? m.eixos_config.map(Number) : Number(m?.qtd_eixos) > 0 ? Array(Number(m.qtd_eixos)).fill(4) : null
  return lista ? { pneus: lista, estepes: m?.estepes === undefined || m?.estepes === null ? 1 : Number(m.estepes) } : null
}
// "2 eixos · 8 pneus"
export const resumoEixos = (m: any): string => { const d = desenhoDoModelo(m); return d ? `${eixosTxt(d.pneus.length)} · ${totalPneus(d.pneus)} pneus` : "—" }
export const payloadDesenho = (d: DesenhoEixos) => ({ eixos_config: d.pneus, estepes: d.estepes })
export const rotuloReboque = (r: any) => [r.placa, [r.marca, r.modelo_veiculo].filter(Boolean).join(" ")].filter(Boolean).join(" · ") || r.nome

// o servidor repete estas regras; aqui so para avisar antes de enviar
export const validarFormReboque = (f: any): string | null => {
  if (!String(f.placa || "").trim()) return "Informe a placa do reboque."
  if (!f.marca_id) return "Escolha a marca do reboque."
  if (!f.modelo_id) return "Escolha o modelo do reboque."
  if (f.ano_fabricacao !== "" && f.ano_fabricacao != null) {
    const n = Number(f.ano_fabricacao)
    if (!Number.isInteger(n) || n < 1950 || n > new Date().getFullYear() + 1) return "Ano de fabricação inválido."
  }
  return null
}
